/**
 * Read the writer's text selection from the markdown editor's textarea
 * without reaching into the (protected) Input component: the editor renders
 * a plain <textarea name="body"> inside the field row, so the toolbar can
 * find it from its own DOM position.
 */

export function getTextareaSelection(el) {
    if (!el || el.tagName !== 'TEXTAREA') return '';
    const start = el.selectionStart;
    const end = el.selectionEnd;
    if (typeof start !== 'number' || typeof end !== 'number' || end <= start) return '';
    return (el.value || '').slice(start, end).trim();
}

export function findBodyTextarea(fromEl) {
    if (!fromEl || typeof fromEl.closest !== 'function') return null;
    const row = fromEl.closest('.compact-field-row');
    if (!row) return null;
    return row.querySelector('textarea[name="body"]');
}
